// Class: motion.actuators.PropertyPathDetails

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function motion_actuators_PropertyDetails() {return require("./../../motion/actuators/PropertyDetails");}

// Constructor

var PropertyPathDetails = function(target,propertyName,path,isField) {
	if(isField == null) {
		isField = true;
	}
	(motion_actuators_PropertyDetails().default).call(this,target,propertyName,0,0,isField);
	this.path = path;
}

// Meta

PropertyPathDetails.__name__ = ["motion","actuators","PropertyPathDetails"];
PropertyPathDetails.__isInterface__ = false;
PropertyPathDetails.__super__ = (motion_actuators_PropertyDetails().default);
PropertyPathDetails.prototype = $extend((motion_actuators_PropertyDetails().default).prototype, {
	
});
PropertyPathDetails.prototype.__class__ = PropertyPathDetails.prototype.constructor = $hxClasses["motion.actuators.PropertyPathDetails"] = PropertyPathDetails;

// Init



// Statics




// Export

exports.default = PropertyPathDetails;